import { envHelper } from './helper';
import { ApiInterface, PlatformType, ChannelType } from './types';
import { TenvideoApi, SportsApi, WeishiApi, YybApi, NoneApi, BbgApi, AcApi } from './channel';

const loginApi = (() => {
  let loginApi: ApiInterface;

  // 端内：直接走端内登录，不区分域名
  switch (envHelper.platform) {
    case PlatformType.TENVIDEO:
      TenvideoApi.staticIsInApp = true;
      loginApi = new TenvideoApi({ isInApp: true });
      break;

    case PlatformType.WEISHI:
      loginApi = new WeishiApi({ isInApp: true });
      break;

    case PlatformType.SPORTS:
      loginApi = new SportsApi({ isInApp: true });
      break;

    case PlatformType.YYB:
      loginApi = new YybApi({ isInApp: true });
      break;

    case PlatformType.BBG:
      loginApi = new BbgApi({ isInApp: true });
      break;

    case PlatformType.AC:
      loginApi = new AcApi({ isInApp: true });
      break;

    default:
      // 端外：按域名区分渠道
      switch (envHelper.channel) {
        case ChannelType.TENVIDEO:
          TenvideoApi.staticIsInApp = true;
          loginApi = new TenvideoApi({ isInApp: false });
          break;

        case ChannelType.WEISHI:
          loginApi = new WeishiApi({ isInApp: false });
          break;

        case ChannelType.SPORTS:
          loginApi = new SportsApi({ isInApp: false });
          break;

        case ChannelType.YYB:
          loginApi = new YybApi({ isInApp: false });
          break;

        case ChannelType.AC:
          loginApi = new AcApi({ isInApp: false });
          break;

        default:
          loginApi = new NoneApi();
          break;
      }
      break;
  }

  return loginApi;
})();

// @ts-ignore
const version = __IWAN_LOGIN_VERSION__ || 'unknown';
console.log(`[iwan-login@${version}] 当前平台：${envHelper.platform}，当前登录渠道：${envHelper.channel}`);

export * from './types';
export default loginApi;
